var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3.775V11.412C1.56019 16.5811 4.8433 21.1621 9.719 22.88L10.84 23.294C11.5889 23.569 12.4111 23.569 13.16 23.294L14.281 22.88C19.1567 21.1621 22.4398 16.5811 22.5 11.412V3.775C22.4979 3.16169 22.1306 2.60864 21.566 2.369C18.5368 1.10465 15.2823 0.468795 12 0.499996C8.71767 0.468795 5.46321 1.10465 2.434 2.369C1.86945 2.60864 1.50205 3.16169 1.5 3.775Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 5.5H16.5L12.146 9.854C10.3852 9.05915 8.30792 9.63634 7.20959 11.2256C6.11125 12.8149 6.30576 14.9621 7.67182 16.3282C9.03787 17.6942 11.1851 17.8887 12.7744 16.7904C14.3637 15.6921 14.9408 13.6148 14.146 11.854L18.5 7.5V5.5Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 14.75C11.1904 14.75 11.75 14.1904 11.75 13.5C11.75 12.8096 11.1904 12.25 10.5 12.25C9.80964 12.25 9.25 12.8096 9.25 13.5C9.25 14.1904 9.80964 14.75 10.5 14.75Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.993d579ebea3415e6e70f1b1872a97d6.svg";
export { ForwardRef as ReactComponent };